<template>
  <div class="container">
    <div class="icons">
      <router-link
        tag="div"
        :class="icon.id === '2' ? 'between' : ''"
        :to="{ path: './' + $route.params.content, query: { ps: icon.name } }"
        v-for="icon in icons"
        :key="icon.id"
      >
        <img
          v-if="icon.id === '1'"
          class="on"
          src="../../assets/img/icon_1_on.svg"
          alt="Icon 1"
        />
        <img
          v-if="icon.id === '1'"
          class="off"
          src="../../assets/img/icon_1_off.svg"
          alt="Icon 1"
        />
        <img
          v-if="icon.id === '2'"
          class="on"
          src="../../assets/img/icon_2_on.svg"
          alt="Icon 2"
        />
        <img
          v-if="icon.id === '2'"
          class="off"
          src="../../assets/img/icon_2_off.svg"
          alt="Icon 2"
        />
        <img
          v-if="icon.id === '3'"
          class="on"
          src="../../assets/img/icon_3_on.svg"
          alt="Icon 3"
        />
        <img
          v-if="icon.id === '3'"
          class="off"
          src="../../assets/img/icon_3_off.svg"
          alt="Icon 3"
        />
        <span>{{ icon.title }}</span>
      </router-link>
    </div>
    <div class="scrollable">
      <div class="content">
        <div class="title">{{ content.title }}</div>
        <div v-html="content.description"></div>
        <div class="parent-container">
          <div class="products-container">
            <div class="product" v-for="product in products" :key="product">
              <div class="product-image">
                <img
                  :src="
                    '../../assets/img/products/' +
                      $route.query.ps +
                      '/' +
                      product +
                      '.png'
                  "
                />
              </div>
              <div class="product-name">{{ product | removePrefix }}</div>
            </div>
          </div>
          <!-- <div class="service-img" :style="{backgroundImage: 'url(' + imgUrl + ')'}"></div> -->
        </div>
      </div>
    </div>
    <LovalFooter :links="links" />
  </div>
</template>

<script>
import LovalFooter from "../LovalFooter";
import axios from "axios";
export default {
  components: {
    LovalFooter
  },
  props: ["content", "icons", "links"],
  data() {
    return { products: [] };
  },
  mounted() {
    this.getProducts(this.$route.query.ps);
  },
  computed: {
    imgUrl() {
      return require("../../assets/img/" + this.content.image);
    }
  },
  watch: {
    content: function() {
      this.products = [];
      this.getProducts(this.$route.query.ps);
    }
  },
  filters: {
    removePrefix: function(value) {
      return value.substr(4);
    }
  },
  methods: {
    getProducts(ps) {
      let url = "../../assets/img/products/" + ps + "/dir.php";
      axios.get(url).then(result => {
        if (Array.isArray(result.data)) {
          this.products = result.data;
        } else {
          this.products = [];
        }
      });
    },
    imgProduct(fileName) {
      // return require("../../assets/img/products/" +
      //   this.$route.query.ps +
      //   "/" +
      //   fileName);
    }
  }
};
</script>
<style lang="scss" scoped>
@import url("./style.scss");
@import url("./industries-style.scss");
// .scrollable {
//   height: calc(100% - var(--nav-title-height) - var(--loval-footer-height));
//   overflow: auto;
//   padding: 10px;
//   box-sizing: border-box;
// }
.products-container {
  display: flex;
  flex-wrap: wrap;
}
.product {
  border: 1px solid lightsteelblue;
  // padding: 2px 5px;
  display: flex;
  align-items: center;
  width: 50%;
  box-sizing: border-box;
  flex-direction: column;
  background-color: white;
}
.product-image {
  width: 100%;
  height: 100%;
}
.product-image img {
  width: 100%;
  height: 150px;
  object-fit: contain;
}
.product-name {
  padding: 2px 5px;
  text-align: center;
  display: flex;
  height: 100%;
  align-items: center;
  font-weight: bold;
}
@media only screen and (min-width: 576px) {
  .product {
    width: calc(100% / 3);
  }
}
@media only screen and (min-width: 768px) {
  .scrollable {
    padding: 30px;
  }
  .product {
    width: calc(100% / 4);
  }
}
@media only screen and (min-width: 1200px) {
  .content {
    padding: 20px 30px;
    background: var(--very-light-blue);
    border-top-left-radius: 30px;
    min-height: calc(100% - 40px);
  }
  .parent-container {
    display: flex;
  }
  .products-container {
    width: 100%;
  }
  .product {
    width: calc(100% / 5);
  }
  // .service-img {
  //   width: 40%;
  //   background-size: cover;
  //   background-position: center;
  // }
}
</style>
